import {setPointerPosition} from '../section.cds2-slider-with-tooltips/initTabs/setPointerPosition';

export const initPointer = ( apartmentCard ) => {
	const pointer = apartmentCard.querySelector( 'li.pointer' );

	if ( !pointer )
	{
		return;
	}

	const apartmentDetails = apartmentCard.querySelector( 'li.apartment-details' );
	const currentOption = apartmentDetails.querySelector( 'input[name="apartment_details"]:checked' ).id;
	const currentLabel = apartmentDetails.querySelector( `label[for="${currentOption}"]` );

	setPointerPosition( currentLabel, pointer );

	apartmentDetails.addEventListener( 'change', ( evt ) => {
		if ( evt.target.name !== 'apartment_details' )
		{
			return;
		}

		const requestedLabel = apartmentDetails.querySelector( `label[for="${evt.target.id}"]` );

		setPointerPosition( requestedLabel, pointer );
	} );
};